import { Controller } from "@hotwired/stimulus";

/**
 * Drives the action buttons on server-rendered error surfaces (full page,
 * retry card, needs-help, status). URL-less actions resolve here by kind;
 * step controllers can override retry behaviour by listening for
 * "error-surface:retry" and calling preventDefault().
 */
export default class ErrorSurfaceController extends Controller {
  static values = { key: String };

  handleAction(event) {
    const kind = event.params.kind;
    switch (kind) {
      case "refresh":
        this.reloadWithoutErrorParams();
        break;
      case "try_again": {
        const retryEvent = new CustomEvent("error-surface:retry", {
          detail: { key: this.keyValue },
          bubbles: true,
          cancelable: true,
        });
        const handled = !this.element.dispatchEvent(retryEvent);
        // Read before dismiss() empties the overlay, or it is always false.
        const overlayCard = this.isOverlayCard();
        this.dismiss();
        if (!handled && !overlayCard) {
          // Full-page surface with no step behind it: reload to a clean state.
          this.reloadWithoutErrorParams();
        }
        break;
      }
      case "send_new_code":
        this.element.dispatchEvent(
          new CustomEvent("error-surface:resend", {
            detail: { key: this.keyValue },
            bubbles: true,
          })
        );
        this.dismiss();
        break;
      default:
        this.dismiss();
    }
  }

  // Error markers in the query string would re-trigger the same surface on a
  // plain reload, looping the customer forever.
  reloadWithoutErrorParams() {
    const url = new URL(window.location.href);
    url.searchParams.delete("error");
    url.searchParams.delete("error_key");
    window.location.assign(url.toString());
  }

  dismiss() {
    const overlay = document.getElementById("error_overlay");
    if (overlay?.contains(this.element)) {
      overlay.innerHTML = "";
    }
  }

  isOverlayCard() {
    const overlay = document.getElementById("error_overlay");
    return Boolean(overlay?.contains(this.element));
  }
}
